import { render, staticRenderFns } from "./FunctionalitiesProfiles.vue?vue&type=template&id=108e610e&scoped=true"
import script from "./FunctionalitiesProfiles.vue?vue&type=script&lang=js"
export * from "./FunctionalitiesProfiles.vue?vue&type=script&lang=js"
import style0 from "./FunctionalitiesProfiles.vue?vue&type=style&index=0&id=108e610e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e610e",
  null
  
)

export default component.exports